import { z } from 'zod'

/**
 * Texto que a API pode mandar nulo ou omitir (DTO anulável, cópias antigas, cliente do login social): vira `''`, para a
 * tela não tratar `null`. Fonte única do helper (antes cada domínio tinha a sua cópia).
 */
export const OptionalTextSchema = z
    .string()
    .nullish()
    .transform((value) => value ?? '')
